function initDaDragSlider() {
  const sliders = document.querySelectorAll('[data-da-drag-slider]');

  sliders.forEach(function (slider) {
    if (slider.dataset.dragReady === 'true') return;
    slider.dataset.dragReady = 'true';

    let isDown = false;
    let startX = 0;
    let startScrollLeft = 0;
    let hasMoved = false;
    let clickBlockTimer = null;

    slider.querySelectorAll('a, img').forEach(function (el) {
      el.setAttribute('draggable', 'false');

      el.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });
    });

    function startDrag(e) {
      if (e.button !== 0) return;

      isDown = true;
      hasMoved = false;
      startX = e.pageX;
      startScrollLeft = slider.scrollLeft;

      slider.classList.add('is-dragging');
      e.preventDefault();
    }

    function moveDrag(e) {
      if (!isDown) return;

      const distance = e.pageX - startX;

      if (Math.abs(distance) > 5) {
        hasMoved = true;
      }

      slider.scrollLeft = startScrollLeft - distance;
      e.preventDefault();
    }

    function stopDrag() {
      if (!isDown) return;

      isDown = false;
      slider.classList.remove('is-dragging');

      clearTimeout(clickBlockTimer);
      clickBlockTimer = setTimeout(function () {
        hasMoved = false;
      }, 180);
    }

    slider.addEventListener('mousedown', startDrag);
    document.addEventListener('mousemove', moveDrag);
    document.addEventListener('mouseup', stopDrag);

    slider.addEventListener('mouseleave', function () {
      if (isDown) {
        stopDrag();
      }
    });

    slider.querySelectorAll('a').forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (hasMoved) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
        }
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', initDaDragSlider);
document.addEventListener('shopify:section:load', initDaDragSlider);
